function updateCollectionProductCard(card, swatchButton) {
    const variantPayload = swatchButton.dataset.variantPayload;
    if (!variantPayload) return;

    let variantData;
    try {
        variantData = JSON.parse(variantPayload);
    } catch (error) {
        return;
    }

    const imageLink = card.querySelector(".collection-all__product-image-link");
    const titleLink = card.querySelector(".collection-all__product-title-link");
    const image = card.querySelector(".collection-all__product-image");
    const variantText = card.querySelector(".collection-all__product-variant");
    const currentPrice = card.querySelector(".collection-all__current-price");
    const oldPrice = card.querySelector(".collection-all__old-price");
    const saleLabel = card.querySelector(".collection-all__product-label--sale");
    const preOrderLabel = card.querySelector(".collection-all__product-label--pre-order");
    const inStockLabel = card.querySelector(".collection-all__product-label--in-stock");
    const outOfStockLabel = card.querySelector(".collection-all__product-label--out-of-stock");

    if (imageLink) imageLink.href = variantData.url;
    if (titleLink) titleLink.href = variantData.url;
    if (image && variantData.image) {
        image.src = variantData.image;
        image.alt = variantData.image_alt;
    }
    if (variantText) {
        variantText.textContent = [variantData.upholstery, variantData.color].filter(Boolean).join(" / ");
    }
    if (currentPrice) currentPrice.textContent = variantData.current_price;
    if (oldPrice) {
        oldPrice.textContent = variantData.old_price;
        oldPrice.hidden = !variantData.show_old_price;
    }
    if (saleLabel) saleLabel.hidden = !variantData.show_sale;
    if (preOrderLabel) preOrderLabel.hidden = variantData.stock_state !== "pre-order";
    if (inStockLabel) inStockLabel.hidden = variantData.stock_state !== "in-stock";
    if (outOfStockLabel) outOfStockLabel.hidden = variantData.stock_state !== "out-of-stock";

    card.querySelectorAll(".collection-all__product-swatch").forEach(function (button) {
        const isActive = button === swatchButton;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
}

function animateCollectionProductImage(card) {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

    const image = card.querySelector(".collection-all__product-image");
    if (!image) return;

    image.classList.remove("is-changing");
    void image.offsetWidth;
    image.classList.add("is-changing");
    image.addEventListener(
        "animationend",
        function () {
            image.classList.remove("is-changing");
        },
        { once: true },
    );
}

function animateCollectionVariantText(card) {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

    const variantText = card.querySelector(".collection-all__product-variant");
    if (!variantText) return;

    variantText.classList.remove("is-changing");
    void variantText.offsetWidth;
    variantText.classList.add("is-changing");
    variantText.addEventListener(
        "animationend",
        function () {
            variantText.classList.remove("is-changing");
        },
        { once: true },
    );
}

function initCollectionProductColorSwatches() {
    document.querySelectorAll(".collection-all__product").forEach(function (card) {
        const swatchButtons = card.querySelectorAll(".collection-all__product-swatch");
        swatchButtons.forEach(function (swatchButton) {
            swatchButton.addEventListener("click", function () {
                updateCollectionProductCard(card, swatchButton);
                animateCollectionProductImage(card);
                animateCollectionVariantText(card);
            });
        });

        const activeSwatchButton = card.querySelector(".collection-all__product-swatch.is-active") || swatchButtons[0];
        if (activeSwatchButton) updateCollectionProductCard(card, activeSwatchButton);
    });
}

$(document).ready(function () {
    initCollectionProductColorSwatches();
});
